
    import { defineComponent, PropType } from 'vue'
    import Dialog from 'primevue/dialog'
    import olapMDXQueryDialogDescriptor from './OlapMDXQueryDialogDescriptor.json'
    import { VCodeMirror } from 'vue3-code-mirror'

    export default defineComponent({
        name: 'olap-custom-view-save-dialog',
        components: {
            Dialog,
            VCodeMirror
        },
        props: { mdxQuery: { type: String as PropType<String | null> } },
        emits: ['close'],
        data() {
            return {
                olapMDXQueryDialogDescriptor,
                query: null as string | null,
                codeMirror: {} as any,
                options: {
                    mode: 'text/x-sql',
                    lineWrapping: true,
                    theme: 'eclipse',
                    lineNumbers: true,
                    readOnly: true
                },
                loading: false
            }
        },
        watch: {
            mdxQuery() {
                this.loadMdxQuery()
            }
        },
        created() {
            this.loadMdxQuery()
        },
        methods: {
            loadMdxQuery() {
                this.query = this.mdxQuery as string
            },
            setupCodeMirror() {
                const interval = setInterval(() => {
                    if (!this.$refs.codeMirror) return
                    this.codeMirror = (this.$refs.codeMirror as any).editor as any
                    setTimeout(() => {
                        this.codeMirror.refresh()
                    }, 0)
                    clearInterval(interval)
                }, 200)
            }
        }
    })
